module.exports = __webpack_public_path__ + "img/T7451-PX.cd1ae714.jpg";